
const FIELD_LABELS = {
  user: 'User',
  embed_url: 'Media file',
  'use_case_embeds.embed_url': 'Media file',
}

const KNOWN_ERROR_PATTERNS = {
  uniqueness: /has already been taken|already exists|already submitted|has already submitted/i,
  blank: /can't be blank|is required|must exist/i,
}

const formatFieldError = (field, errors) => {
  const fieldLabel = FIELD_LABELS[field] || field.replace(/_/g, ' ')
  const firstError = errors[0] || ''

  // Check for blank/required fields
  if (KNOWN_ERROR_PATTERNS.blank.test(firstError)) {
    return `${fieldLabel} is required`
  }

  // Default: combine field label with error message
  return `${fieldLabel} ${firstError}`
}

const isDuplicateSubmissionError = (errors) => {
  if (!errors || typeof errors !== 'object') return false

  // Check if user field has uniqueness error
  if (errors.user) {
    const userErrors = Array.isArray(errors.user) ? errors.user : [errors.user]
    return userErrors.some(err => KNOWN_ERROR_PATTERNS.uniqueness.test(err))
  }

  return false
}

export const parseValidationErrors = (error, is3dPrintModel) => {
  // Check if we have response data
  if (!error?.response?.data) {
    return is3dPrintModel
      ? 'Failed to post 3D Make. Please try again.'
      : 'Failed to post Use Case. Please try again.'
  }

  const { data } = error.response

  // Check for duplicate submission (user uniqueness validation)
  if (isDuplicateSubmissionError(data)) {
    return is3dPrintModel
      ? 'You\'ve already shared a 3D Make for this model. Each buyer can submit ' +
        'only one 3D Make per model to keep things organized'
      : 'You\'ve already shared a Use Case for this model. Each buyer can submit ' +
        'only one Use Case per model to keep things organized'
  }

  // Parse validation errors
  const errorMessages = []

  Object.entries(data).forEach(([field, fieldErrors]) => {
    // Skip non-validation fields (like status, message, etc.)
    if (typeof fieldErrors === 'string' || !Array.isArray(fieldErrors)) return

    const message = formatFieldError(field, fieldErrors)
    errorMessages.push(message)
  })

  // If we found validation errors, return them
  if (errorMessages.length > 0) {
    return errorMessages.join('. ')
  }

  // Fallback: check if there's a general message field
  if (data.message && typeof data.message === 'string') {
    return data.message
  }

  if (data.error && typeof data.error === 'string') {
    return data.error
  }

  // Final fallback
  return is3dPrintModel
    ? 'Failed to post 3D Make. Please check your input and try again.'
    : 'Failed to post Use Case. Please check your input and try again.'
}

export { FIELD_LABELS, KNOWN_ERROR_PATTERNS, formatFieldError, isDuplicateSubmissionError }
